import { Server } from "./class";

const EQHUB_AG_URL = process.env.REACT_APP_EQHUB_AG_URL;

export const userServer = new Server({ baseURL: EQHUB_AG_URL });
export const swapServer = new Server({ baseURL: EQHUB_AG_URL });
export const walletManageServer = new Server({ baseURL: EQHUB_AG_URL });
export const microChainCurrencyServer = new Server({ baseURL: EQHUB_AG_URL });
export const blockExplorerServer = new Server({ baseURL: EQHUB_AG_URL });
export const requestServer = new Server({ baseURL: EQHUB_AG_URL });
export const contractServer = new Server({ baseURL: EQHUB_AG_URL });
export const microChainServer = new Server({ baseURL: EQHUB_AG_URL });
export const networkServer = new Server({ baseURL: EQHUB_AG_URL });

export const addAccessTokenToHeader = (accessToken: string) => {
  const Authorization = `Bearer ${accessToken}`;
  userServer.updateRequestHeader({ Authorization });
  swapServer.updateRequestHeader({ Authorization });
  walletManageServer.updateRequestHeader({ Authorization });
  microChainCurrencyServer.updateRequestHeader({ Authorization });
  blockExplorerServer.updateRequestHeader({ Authorization });
  requestServer.updateRequestHeader({ Authorization });
  contractServer.updateRequestHeader({ Authorization });
  microChainServer.updateRequestHeader({ Authorization });
  networkServer.updateRequestHeader({ Authorization });
};
